import { useAppSelector } from 'src/store/hooks';
import { Loader } from './Loader';

export const LoaderComponent: React.FC = () => {
  const isLoading = useAppSelector(state => state.loader.isLoading);
  return <Loader open={isLoading} />;
};
